import type React from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCurrentPage } from "../store/features/appStateSlice";
import type { AppDispatch } from "../store";

const PageStateHandler: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const path = location.pathname;
    let page = "trucks";
    let metadata = {};

    // Handle different routes
    if (path === "/retiredTrucks") {
      page = "retiredTrucks";
    } else if (path === "/trucks") {
      page = "trucks";
    } else if (path.startsWith("/trucks/groups/")) {
      page = "truckGroup";
      const groupId = path.split("/").pop();
      if (groupId && groupId !== "create") {
        metadata = { id: groupId };
      }
    } else if (path === "/dashboard") {
      page = "dashboard";
    } else if (path === "/users") {
      page = "users";
    } else if (path === "/locations") {
      page = "locations";
    } else if (path === "/settings") {
      page = "settings";
    } else if (path === "/profile" || path.startsWith("/profile/")) {
      page = "profile";
    } else if (path === "/tutorial") {
      page = "tutorial";
    }

    dispatch(setCurrentPage({ page, metadata }));
  }, [location.pathname, dispatch]);

  return null;
};

export default PageStateHandler;
